import React from "react";

// Cup-path card body (brief §0.3 — richer than the artboard's one-line KO
// mock; the build brief is newer and marked DECIDED, and its §2 symbol list
// explicitly names ✓ and → "in the cup-path card"):
//   ✓ completed rounds with score (+ agg where present),
//   → current/next round with opponent + date, TBD chip when undrawn,
//   max 4 rows, older completed rounds collapse to "+n earlier rounds".
// Eliminated/season over → the PARENT renders no card at all (buildCupPath
// returns null). Typography follows the handoff card tokens.
//
// props.cupPath = { rows: [{kind:'done'|'next', label, opponent, score,
// agg, date, tbd}], earlierCount, currentRound } from buildCupPath().

const CupPathCard = ({ cupPath }) => {
  if (!cupPath || !Array.isArray(cupPath.rows) || !cupPath.rows.length) {
    return null;
  }
  return (
    <div style={{ paddingTop: 8 }}>
      {cupPath.earlierCount > 0 && (
        <div
          style={{
            fontSize: 10,
            color: "#94A3B8",
            padding: "0 2px 4px 2px",
            borderBottom: "1px solid #EDF1F6",
          }}
        >
          {`+${cupPath.earlierCount} earlier rounds`}
        </div>
      )}
      {cupPath.rows.map((row, i) => (
        <div
          key={`${row.label}-${i}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            padding: "5px 2px",
            color: row.kind === "next" ? "#0F172A" : "#334155",
            fontWeight: row.kind === "next" ? 600 : 500,
            minWidth: 0,
          }}
        >
          <span
            style={{
              flex: "0 0 14px",
              textAlign: "center",
              color: row.kind === "done" ? "#16A34A" : "#2183FE",
              fontWeight: 700,
            }}
          >
            {row.kind === "done" ? "✓" : "→"}
          </span>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: 0,
            }}
          >
            {row.label}
            {row.opponent ? ` · ${row.opponent}` : ""}
            {row.kind === "next" && row.date ? ` · ${row.date}` : ""}
          </span>
          {row.kind === "done" && row.score ? (
            <span
              style={{
                marginLeft: "auto",
                fontWeight: 700,
                color: "#334155",
                flex: "0 0 auto",
              }}
            >
              {row.score}
              {row.agg ? (
                <span
                  style={{ fontWeight: 500, color: "#94A3B8", marginLeft: 4 }}
                >
                  {`(agg ${row.agg})`}
                </span>
              ) : null}
            </span>
          ) : null}
          {row.kind === "next" && row.tbd ? (
            <span
              style={{
                marginLeft: "auto",
                flex: "0 0 auto",
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: ".06em",
                color: "#475569",
                border: "1px solid #E2E8F0",
                background: "#F8FAFC",
                borderRadius: 3,
                padding: "3px 5px",
              }}
            >
              TBD
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default CupPathCard;
